import React, { useEffect, useState } from 'react';
import {
  Button,
  Container,
  Grid,
  TextField,
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Checkbox
} from '@material-ui/core';
import {
  DeleteOutlined,
  GetApp,
  Search,
  TrendingUp,
  AttachMoney,
  ShoppingCart,
  Person,
  LocationOn,
  PictureAsPdf
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@material-ui/data-grid';
import { Autocomplete } from '@material-ui/lab';
import { ErrorMessage, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from "react-toastify";

import CustomizedDialogs from '../dialog';
import BonClientService from '../../services/BonClientService';
import ClientService from '../../services/ClientService';
import TypeClientService from '../../services/TypeClientService';
import PayeBon from '../PayeBon';
import PayementForm from '../PayementForm';
import generatePDFBon from '../../utils/factureUtils';

const useStyles = makeStyles((theme) => ({
  root: {
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    minHeight: '100vh',
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  header: {
    textAlign: 'center',
    marginBottom: theme.spacing(4),
  },
  title: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontWeight: 700,
    fontSize: '2.5rem',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
  subtitle: {
    color: '#6c757d',
    fontSize: '1.1rem',
  },
  filterCard: {
    borderRadius: 16,
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    background: 'white',
  },
  tableCard: {
    borderRadius: 16,
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    background: 'white',
  },
  statsCard: {
    borderRadius: 16,
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    background: 'white',
  },
  formControl: {
    minWidth: 200,
    marginRight: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      '&:hover fieldset': {
        borderColor: '#226D68',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#226D68',
        borderWidth: '2px',
      },
    },
  },
  searchButton: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    color: 'white',
    fontWeight: 600,
    padding: theme.spacing(1.5),
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(34, 109, 104, 0.3)',
    '&:hover': {
      background: 'linear-gradient(135deg, #1a5a55 0%, #22746d 100%)',
      transform: 'translateY(-2px)',
    },
    transition: 'all 0.3s ease',
  },
  exportButton: {
    background: 'linear-gradient(135deg, #f26522 0%, #ff8c42 100%)',
    color: 'white',
    fontWeight: 600,
    padding: theme.spacing(1.5),
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(242, 101, 34, 0.3)',
    '&:hover': {
      background: 'linear-gradient(135deg, #e55a1a 0%, #ff7b2e 100%)',
      transform: 'translateY(-2px)',
    },
    transition: 'all 0.3s ease',
  },
  statChip: {
    fontWeight: 600,
    fontSize: '0.9rem',
    '&.total': {
      background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
      color: 'white',
    },
    '&.amount': {
      background: 'linear-gradient(135deg, #f26522 0%, #ff8c42 100%)',
      color: 'white',
    },
    '&.client': {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
    },
    '&.ipm': {
      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      color: 'white',
    },
  },
  infoContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  statusChip: {
    fontWeight: 600,
    '&.paid': {
      backgroundColor: '#28a745',
      color: 'white',
    },
    '&.unpaid': {
      backgroundColor: '#dc3545',
      color: 'white',
    },
  },
  deleteIcon: {
    color: '#dc3545',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      color: '#c82333',
      transform: 'scale(1.1)',
    },
  },
  pdfIcon: {
    color: '#d32f2f',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      color: '#b71c1c',
      transform: 'scale(1.1)',
    },
  },
  dataGridHeader: {
    backgroundColor: '#226D68 !important',
    color: 'white !important',
    fontWeight: '600 !important',
  },
  dateFilterContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
}));

const ListBonClient = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [data, setData] = useState([]);
  const [type, setType] = useState([]);
  const [filters, setFilters] = useState([]);
  const [idClient, setIdClient] = useState();
  const [sort, setSort] = useState("NON_PAYER");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dateFilter, setDateFilter] = useState({
    startDate: '',
    endDate: ''
  });

  const handleDelete = async (id) => {
    await BonClientService.annulerBon(id)
      .then((response) => {
        toast.success(response.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        refreshBons();
        setSelectedRows(prev => prev.filter(rowId => rowId !== id));
      })
      .catch((error) => {
        console.log(error);
        toast.error("Erreur lors de la suppression", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };

  // Fonction pour générer le PDF d'une seule ligne
  const handleSinglePDF = (rowData) => {
    try {
      const clientInfo = filters.find(client => client.idClient === idClient);
      const fileName = generatePDFBon([rowData], clientInfo);
      
      toast.success(`Facture "${fileName}" générée avec succès`, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      console.error('Erreur génération PDF:', error);
      toast.error("Erreur lors de la génération de la facture", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  // Fonction pour générer le PDF des lignes sélectionnées
  const handleMultiplePDF = () => {
    if (selectedRows.length === 0) {
      toast.warning("Veuillez sélectionner au moins un bon", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    try {
      const clientInfo = filters.find(client => client.idClient === idClient);
      const selectedData = data.filter(row => selectedRows.includes(row.idBon));
      const fileName = generatePDFBon(selectedData, clientInfo);
      
      toast.success(`Facture "${fileName}" générée avec succès (${selectedRows.length} bons)`, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      console.error('Erreur génération PDF:', error);
      toast.error("Erreur lors de la génération de la facture", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  const handleExportPDF = () => {
    if (data.length === 0) {
      toast.warning("Aucune donnée à exporter", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
  
    try {
      const clientInfo = filters.find(client => client.idClient === idClient);
      const fileName = generatePDFBon(data, clientInfo);
      
      toast.success(`Facture "${fileName}" générée avec succès`, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      console.error('Erreur génération PDF:', error);
      toast.error("Erreur lors de la génération de la facture", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  // Fonction pour appliquer le filtre par date
  const applyDateFilter = (bons) => {
    if (!dateFilter.startDate && !dateFilter.endDate) {
      return bons;
    }

    return bons.filter(bon => {
      const bonDate = new Date(bon.dateEnreg);
      let passFilter = true;

      if (dateFilter.startDate) {
        const startDate = new Date(dateFilter.startDate);
        startDate.setHours(0, 0, 0, 0);
        passFilter = passFilter && bonDate >= startDate;
      }

      if (dateFilter.endDate) {
        const endDate = new Date(dateFilter.endDate);
        endDate.setHours(23, 59, 59, 999);
        passFilter = passFilter && bonDate <= endDate;
      }

      return passFilter;
    });
  };

  // Fonction pour réinitialiser le filtre date
  const resetDateFilter = () => {
    setDateFilter({
      startDate: '',
      endDate: ''
    });
  };

  const columns = [
    {
      field: 'selection',
      headerName: '',
      width: 60,
      headerClassName: classes.dataGridHeader,
      renderCell: (params) => (
        <Checkbox
          checked={selectedRows.includes(params.row.idBon)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedRows(prev => [...prev, params.row.idBon]);
            } else {
              setSelectedRows(prev => prev.filter(id => id !== params.row.idBon));
            }
          }}
        />
      ),
    },
    {
      field: 'beneficiaire',
      headerName: 'Bénéficiaire',
      width: 150,
      headerClassName: classes.dataGridHeader,
    },
    {
      field: 'qtVdu',
      headerName: 'Quantité',
      width: 140,
      headerClassName: classes.dataGridHeader,
    },
    {
      field: 'nomProd',
      headerName: 'Produit',
      width: 200,
      headerClassName: classes.dataGridHeader,
    },
    {
      field: 'prixProdVendu',
      headerName: 'Prix Unitaire',
      width: 150,
      headerClassName: classes.dataGridHeader,
      valueFormatter: (params) => `${params.value?.toLocaleString()} Fcfa`,
    },
    {
      field: 'total',
      headerName: 'Total',
      width: 130,
      headerClassName: classes.dataGridHeader,
      valueFormatter: (params) => `${params.value?.toLocaleString()} Fcfa`,
    },
    {
      field: 'total_remise',
      headerName: 'Remise',
      width: 130,
      headerClassName: classes.dataGridHeader,
      valueFormatter: (params) => `${params.value?.toLocaleString()} Fcfa`,
    },
    {
      field: 'dateEnreg',
      headerName: 'Création',
      width: 130,
      headerClassName: classes.dataGridHeader,
      valueFormatter: (params) => new Date(params.value).toLocaleDateString('fr-FR'),
    },
    {
      field: 'statut',
      headerName: 'Statut',
      width: 120,
      headerClassName: classes.dataGridHeader,
      renderCell: (params) => (
        <Chip
          label={params.value}
          className={`${classes.statusChip} ${params.value === 'PAYER' ? 'paid' : 'unpaid'}`}
          size="small"
        />
      ),
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 200,
      headerClassName: classes.dataGridHeader,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={1}>
          {params.row.statut === 'NON_PAYER' && (
            <CustomizedDialogs title="Payer" boutonTitle="Payer" refresh={refreshBons}>
              <PayeBon idBon={params.row.idBon} />
            </CustomizedDialogs>
          )}
          {params.row.statut === 'PAYER' && (
            <>
              <PictureAsPdf 
                className={classes.pdfIcon} 
                onClick={() => handleSinglePDF(params.row)}
                titleAccess="Générer PDF"
              />
              <DeleteOutlined 
                className={classes.deleteIcon} 
                onClick={() => handleDelete(params.row.idBon)} 
              />
            </>
          )}
        </Box>
      ),
    },
  ];

  const columnIPMs = [
    {
      field: 'selection',
      headerName: '',
      width: 60,
      headerClassName: classes.dataGridHeader,
      renderCell: (params) => (
        <Checkbox
          checked={selectedRows.includes(params.row.idBon)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedRows(prev => [...prev, params.row.idBon]);
            } else {
              setSelectedRows(prev => prev.filter(id => id !== params.row.idBon));
            }
          }}
        />
      ),
    },
    {
      field: 'nom',
      headerName: 'Nom',
      width: 180,
      headerClassName: classes.dataGridHeader,
    },
    {
      field: 'adresse',
      headerName: 'Adresse',
      width: 120,
      headerClassName: classes.dataGridHeader,
    },
    {
      field: 'beneficiaire',
      headerName: 'Bénéficiaire',
      width: 110,
      headerClassName: classes.dataGridHeader,
    },
    {
      field: 'qtVdu',
      headerName: 'Quantité',
      width: 90,
      headerClassName: classes.dataGridHeader,
    },
    {
      field: 'nomProd',
      headerName: 'Produit',
      width: 180,
      headerClassName: classes.dataGridHeader,
    },
    {
      field: 'prixProdVendu',
      headerName: 'Prix',
      width: 120,
      headerClassName: classes.dataGridHeader,
      valueFormatter: (params) => `${params.value?.toLocaleString()} Fcfa`,
    },
    {
      field: 'total_client',
      headerName: 'Client',
      width: 120,
      headerClassName: classes.dataGridHeader,
      valueFormatter: (params) => `${params.value?.toLocaleString()} Fcfa`,
    },
    {
      field: 'total_ipm',
      headerName: 'IPM',
      width: 120,
      headerClassName: classes.dataGridHeader,
      valueFormatter: (params) => `${params.value?.toLocaleString()} Fcfa`,
    },
    {
      field: 'statut',
      headerName: 'Statut',
      width: 120,
      headerClassName: classes.dataGridHeader,
      renderCell: (params) => (
        <Chip
          label={params.value}
          className={`${classes.statusChip} ${params.value === 'PAYER' ? 'paid' : 'unpaid'}`}
          size="small"
        />
      ),
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 200,
      headerClassName: classes.dataGridHeader,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={1}>
          {params.row.statut === 'NON_PAYER' && (
            <CustomizedDialogs title="Payer" boutonTitle="Payer" refresh={refreshBons}>
              <PayeBon idBon={params.row.idBon} />
            </CustomizedDialogs>
          )}
          {params.row.statut === 'PAYER' && (
            <>
              <PictureAsPdf 
                className={classes.pdfIcon} 
                onClick={() => handleSinglePDF(params.row)}
                titleAccess="Générer PDF"
              />
              <DeleteOutlined 
                className={classes.deleteIcon} 
                onClick={() => handleDelete(params.row.idBon)} 
              />
            </>
          )}
        </Box>
      ),
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await TypeClientService.getTypeClient();
        setType(response.data);
      } catch (error) {
        console.log(error);
        toast.error("Erreur lors du chargement des types de client", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleStatut = async (e) => {
    setSort(e.target.value);
    if (idClient) {
      setLoading(true);
      try {
        const response = await BonClientService.getBonClientByStatut(idClient, e.target.value);
        setData(response.data);
        setSelectedRows([]); // Réinitialiser la sélection quand on change de statut
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleFilters = async (e) => {
    const value = e.target.value;
    setLoading(true);
    try {
      const response = await ClientService.getTypeClient(value);
      setFilters(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const initialValues = {
    idClient: '',
  };

  const validationSchema = Yup.object().shape({
    idClient: Yup.number().required("Le client est requis"),
  });

  const onSubmit = async (values, props) => {
    console.log("Form submitted with values:", values);
    setLoading(true);
    try {
      setIdClient(values.idClient);
      const response = await BonClientService.getBonByClient(values.idClient);
      setData(response.data);
      setSelectedRows([]); // Réinitialiser la sélection quand on change de client
      toast.success(`${response.data.length} bons trouvés`, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error) {
      console.log(error);
      toast.error("Erreur lors de la recherche", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } finally {
      setLoading(false);
    }
  };

  const refreshBons = async () => {
    if (idClient) {
      setLoading(true);
      try {
        const response = await BonClientService.getBonByClient(idClient);
        setData(response.data);
        setSelectedRows([]); // Réinitialiser la sélection après refresh
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const filteredData = applyDateFilter(data);
  const totalAmount = filteredData.reduce((a, v) => a + (v.total || 0), 0);
  const totalClient = filteredData.reduce((a, v) => a + (v.total_client || 0), 0);
  const totalIpm = filteredData.reduce((a, v) => a + (v.total_ipm || 0), 0);
  // const isIPMType = filters[0]?.designation.toUpperCase() === "IPM RIDWAN";
  const selectedClient = filters.find(client => client.idClient === idClient);
  const isIPMType = selectedClient?.designation?.toUpperCase() === "IPM RIDWAN";

  return (
    <div className={classes.root}>
      <Container maxWidth="xl">
      
        {/* Carte de filtres */}
        <Card className={classes.filterCard}>
          <CardContent>
            <Box display="flex" alignItems="center" mb={2}>
              <Search style={{ marginRight: 8, color: '#226D68' }} />
              <Typography variant="h5" style={{ color: '#226D68', fontWeight: 600 }}>
                Recherche et Filtres
              </Typography>
            </Box>

            <Formik 
              initialValues={initialValues} 
              validationSchema={validationSchema} 
              onSubmit={onSubmit}
            >
              {(props) => (
                <Form>
                  <Grid container spacing={3} alignItems="center">
                    {/* Type Client */}
                    <Grid item xs={12} md={3}>
                      <FormControl variant="outlined" className={classes.formControl} fullWidth>
                        <InputLabel>Type Client</InputLabel>
                        <Select
                          label="Type Client"
                          onChange={handleFilters}
                          disabled={loading}
                        >
                          <MenuItem value="">
                            <em>Tous les types</em>
                          </MenuItem>
                          {type.map((typeItem) => (
                            <MenuItem key={typeItem.idType} value={typeItem.idType}>
                              {typeItem.designation}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* Sélection Client */}
                    <Grid item xs={12} md={3}>
                      <Autocomplete
                        id="idClient"
                        name="idClient"
                        options={filters}
                        getOptionLabel={(option) => option.nom || ''}
                        onChange={(e, value) => {
                          console.log("Autocomplete value selected:", value);
                          props.setFieldValue("idClient", value?.idClient || '');
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Nom Client"
                            variant="outlined"
                            fullWidth
                            error={props.errors.idClient && props.touched.idClient}
                            helperText={<ErrorMessage name="idClient" />}
                            disabled={loading}
                          />
                        )}
                      />
                    </Grid>

                    {/* Filtre Statut */}
                    <Grid item xs={12} md={2}>
                      <FormControl variant="outlined" className={classes.formControl} fullWidth>
                        <InputLabel>Statut</InputLabel>
                        <Select
                          label="Statut"
                          value={sort}
                          onChange={handleStatut}
                          disabled={loading || !idClient}
                        >
                          <MenuItem value="NON_PAYER">NON PAYÉ</MenuItem>
                          <MenuItem value="PAYER">PAYÉ</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* Filtres Date */}
                    <Grid item xs={12} md={3}>
                      <Box className={classes.dateFilterContainer}>
                        <TextField
                          label="Date début"
                          type="date"
                          value={dateFilter.startDate}
                          onChange={(e) => setDateFilter(prev => ({...prev, startDate: e.target.value}))}
                          InputLabelProps={{ shrink: true }}
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                        <TextField
                          label="Date fin"
                          type="date"
                          value={dateFilter.endDate}
                          onChange={(e) => setDateFilter(prev => ({...prev, endDate: e.target.value}))}
                          InputLabelProps={{ shrink: true }}
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                        {(dateFilter.startDate || dateFilter.endDate) && (
                          <Button 
                            variant="outlined" 
                            color="secondary" 
                            onClick={resetDateFilter}
                            size="small"
                            style={{ minWidth: 'auto' }}
                          >
                            Reset
                          </Button>
                        )}
                      </Box>
                    </Grid>

                    {/* Bouton Valider */}
                    <Grid item xs={12} md={1}>
                      <Button
                        type="submit"
                        className={classes.searchButton}
                        variant="contained"
                        fullWidth
                        disabled={loading || !props.values.idClient}
                        startIcon={loading ? <CircularProgress size={20} /> : <Search />}
                      >
                        {loading ? '...' : 'OK'}
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </CardContent>
        </Card>

        {/* Statistiques */}
        {filteredData.length > 0 && (
          <Card className={classes.statsCard}>
            <CardContent>
              <Box className={classes.infoContainer}>
                {/* Informations du client */}
                {filters.find(client => client.idClient === idClient) && (
                  <>
                    <Chip
                      icon={<Person style={{ color: 'white' }} />}
                      label={`Client: ${filters.find(client => client.idClient === idClient)?.nom}`}
                      className={`${classes.statChip} client`}
                      style={{ 
                        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
                        color: 'white'
                      }}
                    />
                    <Chip
                      icon={<LocationOn style={{ color: 'white' }} />}
                      label={`Adresse: ${filters.find(client => client.idClient === idClient)?.adresse || 'Non renseignée'}`}
                      className={`${classes.statChip} client`}
                      style={{ 
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white'
                      }}
                    />
                  </>
                )}
                
                <Chip
                  icon={<ShoppingCart style={{ color: 'white' }} />}
                  label={`${filteredData.length} ${filteredData.length === 1 ? 'vente' : 'ventes'}`}
                  className={`${classes.statChip} total`}
                />
                <Chip
                  icon={<AttachMoney style={{ color: 'white' }} />}
                  label={`${totalAmount.toLocaleString()} Fcfa`}
                  className={`${classes.statChip} amount`}
                />
                
                {isIPMType && (
                  <>
                    <Chip
                      icon={<TrendingUp style={{ color: 'white' }} />}
                      label={`Part Client: ${totalClient.toLocaleString()} Fcfa`}
                      className={`${classes.statChip} client`}
                    />
                    <Chip
                      icon={<TrendingUp style={{ color: 'white' }} />}
                      label={`Part IPM: ${totalIpm.toLocaleString()} Fcfa`}
                      className={`${classes.statChip} ipm`}
                    />
                  </>
                )}

                {/* Bouton PDF multiple */}
                {selectedRows.length > 0 && (
                  <Button
                    className={classes.exportButton}
                    variant="contained"
                    onClick={handleMultiplePDF}
                    startIcon={<PictureAsPdf />}
                    size="small"
                  >
                    PDF ({selectedRows.length})
                  </Button>
                )}

                {filteredData.length > 0 && sort === 'NON_PAYER' && (
                  <CustomizedDialogs title="Payer tout" boutonTitle="Payer tout" refresh={refreshBons}>
                    <PayementForm bons={filteredData} />
                  </CustomizedDialogs>
                )}

                {/* Bouton Export PDF de tous les bons */}
                <Button
                  className={classes.exportButton}
                  variant="contained"
                  fullWidth
                  disabled={filteredData.length === 0 || loading}
                  onClick={handleExportPDF}
                  startIcon={<GetApp />}
                  size="small"
                >
                  Tout exporter
                </Button>
              </Box>

              {/* Indicateur de filtre date actif */}
              {(dateFilter.startDate || dateFilter.endDate) && (
                <Box mt={1}>
                  <Typography variant="body2" color="textSecondary">
                    Filtre date: 
                    {dateFilter.startDate && ` Du ${new Date(dateFilter.startDate).toLocaleDateString('fr-FR')}`}
                    {dateFilter.endDate && ` Au ${new Date(dateFilter.endDate).toLocaleDateString('fr-FR')}`}
                    {` (${filteredData.length} résultat(s))`}
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        )}

        {/* Tableau des données */}
        <Card className={classes.tableCard}>
          <CardContent style={{ padding: 0 }}>
            {loading ? (
              <Box display="flex" justifyContent="center" alignItems="center" height={200}>
                <CircularProgress size={40} style={{ color: '#226D68' }} />
              </Box>
            ) : filteredData.length > 0 ? (
              <div style={{ height: 500, width: '100%' }}>
                <DataGrid
                  rows={filteredData}
                  columns={isIPMType ? columnIPMs : columns}
                  pageSize={10}
                  getRowId={(row) => row.idBon}
                  checkboxSelection={false}
                  disableSelectionOnClick
                />
              </div>
            ) : (
              <Box textAlign="center" py={4}>
                <Search style={{ fontSize: 64, color: '#ccc', marginBottom: 16 }} />
                <Typography variant="h6" color="textSecondary" gutterBottom>
                  Aucune donnée trouvée
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Utilisez les filtres pour afficher les résultats
                </Typography>
              </Box>
            )}
          </CardContent>
        </Card>
      </Container>
    </div>
  );
};

export default ListBonClient;